import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { CostSection } from './components/CostSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { BonusValueSection } from './components/BonusValueSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full bg-ivory font-sans text-ink" data-id="element-0" data-mp="28sbend1g9lav">
      <Hero data-id="element-1" data-mp="23u9vyt7xrnzx" />
      <main data-id="element-2" data-mp="23utbk3a460as">
        <ProblemSection data-id="element-3" data-mp="23v2td3l0915e" />
        <CostSection data-id="element-4" data-mp="3ijxnsm94vshs" />
        <SolutionSection data-id="element-5" data-mp="3ikh5c1uvgeva" />
        <VolumesSection data-id="element-6" data-mp="3ij65ue8glt9z" />
        <BonusesSection data-id="element-7" data-mp="3ihv2ugmu8pjx" />
        <BonusValueSection data-id="element-8" data-mp="3mlawd43m29se" />
        <OfferSection data-id="element-9" data-mp="3mkhlps1j704z" />
        <GuaranteeSection data-id="element-10" data-mp="3mjzu58ptda3e" />
        <TestimonialsSection data-id="element-11" data-mp="3mj6jvxrnc2gi" />
        <FaqSection data-id="element-12" data-mp="3rbrbqtqzs5he" />
        <FinalCtaSection data-id="element-13" data-mp="3rdatypw7kqlt" />
      </main>
      <Footer data-id="element-14" data-mp="3recc1ebn6dd1" />
      <StickyCta data-id="element-15" data-mp="5yhupa6n3cr" />
    </div>;
}